var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#E2E2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONTACT"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    transform: "translate(-372 -494)",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 9",
    filter: "url(#filter0_d_761_6465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -161,
    y: -74,
    width: 369,
    height: 256,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "healthicons:mobile-outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "healthicons:group-discussion-meeting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12.0415C24 11.2481 23.8437 10.4624 23.5401 9.72935C23.2364 8.9963 22.7914 8.33024 22.2303 7.76918C21.6693 7.20813 21.0032 6.76308 20.2701 6.45944C19.5371 6.1558 18.7514 5.99952 17.958 5.99952H12.042C11.242 5.98923 10.448 6.1379 9.70604 6.43689C8.96402 6.73589 8.28878 7.17926 7.71947 7.74129C7.15017 8.30332 6.69814 8.9728 6.38963 9.71091C6.08111 10.449 5.92224 11.241 5.92224 12.041C5.92224 12.841 6.08111 13.633 6.38963 14.3711C6.69814 15.1092 7.15017 15.7787 7.71947 16.3408C8.28878 16.9028 8.96402 17.3462 9.70604 17.6452C10.448 17.9441 11.242 18.0928 12.042 18.0825H13.2V20.9995C13.2 20.9995 24 19.5415 24 12.0415ZM18.5 27.9995C18.5 30.2095 16.71 31.9995 14.5 31.9995C12.29 31.9995 10.5 30.2095 10.5 27.9995C10.5 25.7895 12.29 23.9995 14.5 23.9995C16.71 23.9995 18.5 25.7895 18.5 27.9995ZM14.5 33.9995C11.663 33.9995 5.99997 35.4295 5.99997 38.2665V41.9995H23V38.2665C23 35.4285 17.337 33.9995 14.5 33.9995ZM33.5 31.9995C35.71 31.9995 37.5 30.2095 37.5 27.9995C37.5 25.7895 35.71 23.9995 33.5 23.9995C31.29 23.9995 29.5 25.7895 29.5 27.9995C29.5 30.2095 31.29 31.9995 33.5 31.9995ZM33.5 33.9995C30.663 33.9995 25 35.4295 25 38.2665V41.9995H42V38.2665C42 35.4285 36.337 33.9995 33.5 33.9995ZM32.042 6.99952C30.4395 6.99952 28.9027 7.63609 27.7696 8.76918C26.6365 9.90228 26 11.4391 26 13.0415C26 20.5415 35.6 21.9995 35.6 21.9995V19.0825H35.958C36.7579 19.0928 37.5519 18.9441 38.2939 18.6452C39.0359 18.3462 39.7112 17.9028 40.2805 17.3408C40.8498 16.7787 41.3018 16.1092 41.6103 15.3711C41.9188 14.633 42.0777 13.841 42.0777 13.041C42.0777 12.241 41.9188 11.449 41.6103 10.7109C41.3018 9.9728 40.8498 9.30332 40.2805 8.74129C39.7112 8.17926 39.0359 7.73589 38.2939 7.43689C37.5519 7.1379 36.7579 6.98923 35.958 6.99952H32.042Z",
    fill: "#677FD9"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TITLES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5452"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_761_6465",
    x: -191,
    y: -100,
    width: 429,
    height: 316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_761_6465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_761_6465",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMeeting);
export default __webpack_public_path__ + "static/media/book-meeting.00f64b74e8e559a0c21da563d4d20270.svg";
export { ForwardRef as ReactComponent };